import React from 'react'
import { Swiper } from '../../components/swiper'
export const LineSwiper = () => {
    return <Swiper interval={1000 * 10} urls={[
        '/line/production?lineCode=2&timeRangeType=week',
        '/line/production?lineCode=2&timeRangeType=month',
        '/line/production?lineCode=2&timeRangeType=totalByYear',
    ]} />
}